// extracted by mini-css-extract-plugin
export var container = "_ci-0";
export var icon = "_ci-1";
export var text = "_ci-2";